import React, { useContext, useEffect } from 'react'
import { ToastContext, useIsTouchScreen, useToast } from '@afterpaytouch/core'
import { revokePersistentSession, useAppDispatch } from '../../state'
import { useMonitoringWithEnduringEventProperties } from '../../integrations/monitoring'
import { TrackingEvent } from '../../model/monitoring'
import { useRoutePageName } from '../../config/router'
import { consumeRememberMeMinted, subscribeRememberMeMinted } from '../../flow/remember-me/issuanceSignal'
import { setOptedOutRememberMe } from '../../flow/remember-me/optOut'
import { ToastMessage } from './ToastMessage'

const TOAST_NAMESPACE = 'auto-remember-me-issuance'

export const useAutoRememberMeIssuanceToast = (): void => {
  const toast = useToast()
  const { setToastList } = useContext(ToastContext)
  const isTouchScreen = useIsTouchScreen()
  const { logEvent } = useMonitoringWithEnduringEventProperties()
  const pageName = useRoutePageName()
  const dispatch = useAppDispatch()

  useEffect(() => {
    const showToast = (): void => {
      const dismiss = (): void => {
        setToastList((list) => list.filter((item) => item.testNameSpace !== TOAST_NAMESPACE))
      }

      const onGotIt = (): void => {
        logEvent(TrackingEvent.PRESSED_AUTO_REMEMBER_ME_ISSUANCE_TOAST_GOT_IT)
        dismiss()
      }

      const onOptOut = (): void => {
        logEvent(TrackingEvent.PRESSED_AUTO_REMEMBER_ME_ISSUANCE_TOAST_OPT_OUT)
        setOptedOutRememberMe()
        void dispatch(revokePersistentSession()).then((result) => {
          if (revokePersistentSession.fulfilled.match(result) && result.payload === true) {
            logEvent(TrackingEvent.REMEMBER_ME_REVOKED, { revokeReason: 'userRevoked', scope: 'this-device', pageName })
          }
        })
        dismiss()
      }

      logEvent(TrackingEvent.VIEWED_AUTO_REMEMBER_ME_ISSUANCE_TOAST, { pageName })
      toast({
        message: () => <ToastMessage onGotIt={onGotIt} onOptOut={onOptOut} />,
        kind: 'Default',
        toastTime: 5000,
        swipeToDismiss: isTouchScreen,
        testNameSpace: TOAST_NAMESPACE,
      })
    }

    const maybeShow = (): void => {
      if (consumeRememberMeMinted()) {
        showToast()
      }
    }
    maybeShow()
    return subscribeRememberMeMinted(maybeShow)
  }, [toast, setToastList, isTouchScreen, logEvent, pageName, dispatch])
}
